var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseGridLayout',{attrs:{"size":"small"}},[_c('ul',{staticClass:"col-span-full list-square"},_vm._l((_vm.data),function(entity,index){return _c('li',{key:`${entity.legalEntity}-${index}`},[_vm._v("\n      "+_vm._s(entity.legalEntity)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }